export enum ErrorCode {
  NOT_FOUND = 404,
}

export enum ResponseCode {
  OK = "OK",
  ER_NOT_FOUND = "ER_NOT_FOUND",
  MAYBE_LOST = "MAYBE_LOST",
  INIT = "INIT",
}

export type Response = {
  code: ResponseCode;
};
